import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, makeObservable } from "mobx";
import isDefined from "../../Core/isDefined";
import { GLYPHS } from "../../Styled/Icon";
import MapNavigationItemController from "../../ViewModels/MapNavigation/MapNavigationItemController";
export const FEEDBACK_TOOL_ID = "feedback";
export let FeedbackButtonController = (_dec = action.bound, _dec2 = action.bound, _class = class FeedbackButtonController extends MapNavigationItemController {
  constructor(viewState) {
    super();
    this.viewState = viewState;
    makeObservable(this);
  }
  get glyph() {
    return GLYPHS.feedback;
  }
  get viewerMode() {
    return undefined;
  }
  activate() {
    this.viewState.feedbackFormIsVisible = true;
    super.activate();
  }
  deactivate() {
    this.viewState.feedbackFormIsVisible = false;
    super.deactivate();
  }
  get visible() {
    return isDefined(this.viewState.terria.configParameters.feedbackUrl) && !this.viewState.hideMapUi && super.visible;
  }
  get active() {
    return this.viewState.feedbackFormIsVisible;
  }
}, _applyDecoratedDescriptor(_class.prototype, "activate", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deactivate", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "deactivate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "active", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "active"), _class.prototype), _class);